import Cookie from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => {
  // header alert
  const headerAlert = document.querySelector('.header-alert');
  const mobileNav = document.querySelector('.header-nav__mobile');

  const alertsClose = document.querySelectorAll('.header-alert__close');

  alertsClose.forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      closeBtn.closest('.header-alert').classList.add('close');
  
      Cookie.set(`header-alert-${closeBtn.id}`, true);
  
      mobileNav.classList.remove('hasAlert');
    });
  })

  // header position
  const header = document.querySelector('.header');

  function headerPosition() {

    const offset = headerAlert != null && headerAlert.offsetHeight;

    window.scrollY >= offset ? header.classList.add('fixed') : header.classList.remove('fixed');
  }

  headerPosition()

  document.addEventListener('scroll', headerPosition);

  // mobile nav
  const toggleNavButtons = Array.from(document.querySelectorAll('.header-toggle'));
  const mobileMenu = document.querySelector('.header-nav__mobile');

  const toggleButtons = () => {
    toggleNavButtons.forEach((toggleNav) => {
      toggleNav.classList.toggle('show');
    });
  };

  toggleNavButtons.forEach((toggleNav) => {
    toggleNav.addEventListener('click', () => {
      toggleButtons();
      mobileMenu.classList.toggle('show');
      document.body.classList.toggle('lock');
    });
  });

  // mobile submenu nav
  const submenuToggles = document.querySelectorAll('.header-nav__mobile .menu-item-has-children');

  submenuToggles.forEach((item) => {
    const toggle = item.querySelector('a');
    const submenu = item.querySelector('ul');

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      submenu.classList.toggle('show');
    });
  });

  const backTootleMenus = document.querySelectorAll('a.backButton');

  backTootleMenus.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      item.parentNode.parentNode.classList.remove('show');
    });
  });
});
